/**
 * @author:
 */

// 钱格式
export const MONEY = /^[0-9]+(\.[0-9]{0,2})?$/;

//手机号码
export const CHECK_PHONENUM = /^1[34578]\d{9}$/;

//验证6-12位字母或数字
export const BBIN_PASSWORD = /^[0-9a-zA-Z]{6,12}$/;

// 正整数
export const POS_INTEGER = /^[1-9]+([0-9]*\d)?$/;